"use strict";
import React from "react";
import { Translation } from "../../../../components/Translation";
const Empty = function() {
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("h4", null, /* @__PURE__ */ React.createElement(Translation, null, "No version record")), /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(Translation, null, "Your version record will be displayed here after release")));
};
export default Empty;
